import { GenericMachine } from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { IDocs } from '_core/types';
import { ErrorsFlowTypes } from '_core/types/Responses';
import { validateEmailApi as API } from '../Apis';

export const ValidateEmailDocs: IDocs = {
  title: 'ValidateEmail',
  description: '',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.AccountServices.validateEmail',
};

const prepareCall = (stateRequestParameters: any) =>
  API.call.post({
    document: stateRequestParameters?.document,
    email: stateRequestParameters.email,
  });

const handleErrorFlowFinalResponseFunction = (infos: ErrorsFlowTypes) => {
  const emailLinkedOtherDocument = infos?.emailLinkedOtherDocument;
  const smilesErrorService =
    infos?.errorService ||
    infos?.emailLinkedDocument ||
    !emailLinkedOtherDocument;

  return { emailLinkedOtherDocument, smilesErrorService };
};

export const ValidateEmailMachine = GenericMachine(
  prepareCall,
  {
    docs: ValidateEmailDocs,
    definitions: API.definitions,
  },
  {
    handleErrorFlowFinalResponseFunction,
  },
);
